<template>
    <div class="variationValues">
        <variation-values-filters @update-filters="onUpdateFilters"  ref="filtersComponent"></variation-values-filters>
        <div class="variationValues-list">

            <div class="pagination">
                <div class="page-subtitle">{{ total_item }} valeurs</div>
                <el-pagination @current-change="page => paginate(page, 'top')" :current-page.sync="params.page" :page-size="params.limit" :pager-count="11" layout="sizes, prev, pager, next" :page-sizes="page_sizes" @size-change="handleSizeChange" :total="total_item"></el-pagination>
                <button @click="openEdit()" class="btn btn-outline-secondary btn-sm">Créer</button>
            </div>
            <el-table style="width: 100%" ref="multipleTable" :data="variationValues" @selection-change="handleSelectionChange" stripe @sort-change="changeSort" v-loading="loading">
                <el-table-column prop="shop_id" label="ID Speedway" sortable="custom" width="150"></el-table-column>
                <el-table-column prop="value" label="Valeur"></el-table-column>
                <el-table-column label="Actions" fixed="right" >
                    <template slot-scope="scope">
                        <template v-if="scope.row.value != '--'">
                            <button :title="scope.row.id" class="btn btn-icon btn-link" @click="openEdit(scope.row)">
                                <i class="fe fe-edit"></i>
                            </button>
                            <button class="btn btn-icon btn-link text-danger" @click.prevent="removeVariationValue(scope.row)" >
                                <i class="fe fe-trash"></i>
                            </button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination :page-size="params.limit" layout="sizes, prev, pager, next" :pager-count="11" :total="total_item" @current-change="page => paginate(page, 'bottom')" :page-sizes="page_sizes" @size-change="handleSizeChange" :current-page="params.page">
                </el-pagination>
            </div>
        </div>
        <el-dialog @closed="closeEdit" title="Création / Modification" v-loading="modal.createEdit.loader" :visible.sync="modal.createEdit.display" width="50%">
            <el-form class="formCreateEdit" ref="formCreateEdit" :rules="rules" :model="modal.createEdit.form" label-position="top">
                <el-form-item prop="value" label="Valeur">
                    <el-input v-model="modal.createEdit.form.value"></el-input>
                </el-form-item>
                <el-form-item prop="shop_id" label="ShopId">
                    <el-input v-model="modal.createEdit.form.shop_id"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modal.createEdit.display = false">Annuler</el-button>
                <el-button type="primary" @click="updateVariationValue">Enregistrer</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import queryString from 'query-string';
import { EventBus } from '../../event-bus';
import VariationValue from '../../models/VariationValue';
export default {
    data() {
        return {
            multipleSelection: [],
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'value',
                order: 'ASC',
                limit: 10
            },
            defaultParams: {
                page: 1,
                orderBy: 'value',
                order: 'ASC',
                limit: 10
            },
            filters: {},
            loading: false,
            rules: {
                value: [
                    {
                        required: true,
                        message: 'Veuillez renseignez une valeur',
                        trigger: 'blur'
                    }
                ],
                shop_id: [
                    {
                        required: true,
                        message: 'Veuillez renseigner un ShopId',
                        trigger: 'blur'
                    },
                ],
            },
            modal: {
                createEdit: {
                    display: false,
                    loader: false,
                    form: { }
                }
            },
        };
    },
    props: {
        variationId: {
            required: true
        }
    },
    computed: {
        total_item() {
            return this.$store.getters['variationValues/totalItems'];
        },
        variationValues() {
            return this.$store.getters['variationValues/items'];
        },
        currentUrl() {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname
            );
        },
        appendSearch() {
            return this.params['product_search'] ? ' '+this.params['product_search']+'&scope=name' : ''
        }
    },
    watch: {
        params: {
            handler(newV, oldV) {
                var newUrl =
                    this.currentUrl + '?' + queryString.stringify(newV);
                window.history.pushState({ path: newUrl }, '', newUrl);
            },
            deep: true
        }
    },
    mounted() {
        this.$store.dispatch('app/setSearchMode', 'variationValues');
        if (window.location.search) {
            var params = queryString.parse(window.location.search);
            for (let key in params) {
                switch (key) {
                    case 'page':
                    case 'limit':
                        params[key] = parseInt(params[key]);
                        break;
                    case 'brand_id':
                    case 'manufacturer_id':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            parseInt(params[key]),
                            true
                        );
                        break;
                    case 'category_id':
                        if (typeof params[key] == 'Array') {
                            var value = params[key].map(v => parseInt(v));
                        } else {
                            var value = [parseInt(params[key])];
                        }

                        this.$refs.filtersComponent.setFilter(key, value, true);
                        break;
                    case 'q':
                        this.$store.dispatch('app/setQ', params[key]);
                        break;
                    case 'product_search':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            params[key],
                            true
                        );
                        break;
                    default:
                        break;
                }
            }
            this.params = params;
        }
        this.fetch();
    },

    methods: {
        removeVariationValue(variationValue)
        {
            this.$confirm('Ceci effacera la valeur. Continuer?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                axios.delete('/variations/' + this.variationId + '/values/'+variationValue.id).then(()=>{
                    this.fetch()
                    this.$message({
                        type: 'success',
                        message: 'Valeur supprimé'
                    });
                }).catch(()=>{

                })

            }).catch(() => {

            });
        },
        updateVariationValue()
        {
            this.$refs.formCreateEdit.validate((valid, errors) => {
                if (valid) {
                    if( this.modal.createEdit.form.id ) {
                        axios
                        .post('/variations/' + this.variationId + '/values/'+this.modal.createEdit.form.id, this.modal.createEdit.form)
                        .then(r => {
                            this.closeEdit()
                            this.$message({
                                message: 'Valeur mise à jour.',
                                type: 'success'
                            });
                            this.fetch()
                        })
                        .catch(e => {
                            if (e.response && e.response.status == 422) {
                                this.$message.error(e.response.data.errors);
                            } else {
                                this.$message.error(
                                    'Erreur lors de la mise à jour.'
                                );
                            }
                        })
                        .then(() => {});
                    } else {
                        axios
                        .post('/variations/' + this.variationId + '/values', this.modal.createEdit.form)
                        .then(r => {
                            this.closeEdit()
                            this.$message({
                                message: 'Valeur créer.',
                                type: 'success'
                            });
                            this.fetch()
                        })
                        .catch(e => {
                            if (e.response && e.response.status == 422) {
                                this.$message.error(e.response.data.errors);
                            } else {
                                this.$message.error(
                                    'Erreur lors de la mise à jour.'
                                );
                            }
                        })
                        .then(() => {});
                    }

                }
            })
        },
        openEdit( variationValue )
        {
            if( !variationValue ) {
                variationValue = new VariationValue
            }
            this.modal.createEdit.form = variationValue.toDatas();
            this.modal.createEdit.display = true;
        },
        closeEdit()
        {
            this.modal.createEdit.form = { };
            this.modal.createEdit.display = false;
        },
        handleSelectionChange(val) {
            this.$store.dispatch('variationValues/setApplyToAllResults', false);
            this.multipleSelection = val;
        },

        fetch(params) {
            if (!params) {
                params = {};
            }
            params = { ...params, ...this.params };
            params.variationId = this.variationId;
            this.loading = true;
            return this.$store.dispatch('variationValues/fetch', params).then(() => {
                this.loading = false;
            });
        },

        goToPage(p) {
            this.params.page = p;
            this.fetch();
        },

        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order == 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },

        removeAllFiltersToParams(params) {
            var newParams = {};
            for (let k in this.defaultParams) {
                newParams[k] = params[k];
            }
            return newParams;
        },

        onUpdateFilters(filters) {
            this.params.page = 1;
            this.params = this.removeAllFiltersToParams(this.params);
            this.params = { ...this.params, ...filters };
            if (!Object.values(filters).length) {
                this.params = Object.assign({}, this.defaultParams);
                setTimeout(() => {
                    window.history.pushState(
                        { path: this.currentUrl },
                        '',
                        this.currentUrl
                    );
                }, 100);
            }
            this.fetch();
        },

        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },

        openModalEdit(variationValue) {
            this.modal.display = true;
            this.modal.variationValue = variationValue.clone();
        },

        closeModalEdit() {
            this.modal.display = false;
        },

        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
                .then(r => {
                    if (paginator == 'bottom') {
                        var element = document.querySelector(
                            '.sizes .size-list'
                        );
                        element.scrollIntoView();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },

        filterInTab(name, value) {
            this.$refs.filtersComponent.setFilter(name, value);
        }
    }
};
</script>
<style lang="scss">
.variationValues {
    .pagination {
        margin: 25px 0;
        .el-pagination {
            margin: 0 auto;
        }
    }
}
</style>
